import { addHeaderToLayout } from "src/app/ReportGenerator/functions/addHeaderToLayout";
import { addSpaceIfNeeded } from "../addSpaceIfNeeded";

export const addSelectedCommentsToLayout = (
  newLayout,
  format,
  campaigns,
  dataAggregation,
  campaignId,
  comments,
) => {
  if (!comments) return;

  const isSingleCampaign = Object.keys(campaigns).length === 1;
  const headerDepth = campaignId !== "aggregated" && !isSingleCampaign ? 3 : 2;

  addHeaderToLayout(`comments-${campaignId}`, newLayout, format, headerDepth);

  Object.keys(comments?.all)?.forEach((commentKey) => {
    const lastEl = addSpaceIfNeeded("comments", newLayout, format);

    let x = 0;
    let y = 0;
    const w = 6;
    const h = 5;

    if (lastEl.w === 12 || lastEl.x === 6) {
      x = 0;
      y = lastEl.y + lastEl.h;
    }
    // second in row and half the width
    else if (lastEl.x === 0) {
      x = lastEl.x + 6;
      y = lastEl.y;
    }

    newLayout.push({ i: `comments-${commentKey}-${campaignId}`, x, y, w, h });
  });
};
